import generatedConfig from '@iotv/config';
import pkg from '../package.json';
import { NavSections } from './venture/v020/navigation/NavSections';
var GoogleChannels;
(function (GoogleChannels) {
    GoogleChannels["quarterly"] = "quarterly";
    GoogleChannels["beta"] = "beta";
})(GoogleChannels || (GoogleChannels = {}));
const getInitialRedirect = (override) => {
    if (override)
        return override;
    return '/' + NavSections.HOMEPAGE;
};
const config = {
    // *.[stage].[projectCode].iotv.link
    internalAccountDomain: generatedConfig.internalAccountDomain,
    // and external tld like teamslats.com
    domain: generatedConfig.domain,
    app: {
        version: pkg.version,
        stage: generatedConfig.stage,
        ...generatedConfig.app,
        initialRedirect: getInitialRedirect(generatedConfig.app.webUI.initialRedirect),
        defaultPreferences: {
            uiTheme: 'light',
        },
        geo: {
            initialCenter: {
                lat: 37.2431,
                lng: -115.793,
            },
            initialZoom: 6,
        },
    },
    aws: {
        ...generatedConfig.aws,
        amplify: {
            logLevel: 'INFO',
        },
    },
    google: {
        clientLibrary: {
            gsi: {
                uri: 'https://accounts.google.com/gsi/client',
            },
            gapi: {
                uri: 'https://apis.google.com/js/client.js',
            },
        },
        mapsApiKey: 'AIzaSyDmOmI2f-zrjs9VAX-8Xzq8Q__OsNDDFXc',
        mapsApiUri: `https://maps.googleapis.com/maps/api/js?key=${'AIzaSyDmOmI2f-zrjs9VAX-8Xzq8Q__OsNDDFXc'}&v=${GoogleChannels.beta}&libraries=geometry,drawing`,
        mapsStaticUri: `https://maps.googleapis.com/maps-api-v3`,
        chartApiUri: 'https://www.gstatic.com/charts/loader.js',
        apiUri: 'https://apis.google.com/js/client.js',
        /* pulls in google.gcp which may or may not be overriden from default by venture */
        ...generatedConfig.google,
        /** await refactor to maps object */
        maps: {
            mapId: 'DEMO_MAP_ID',
        },
    },
    locale: 'en-NZ', // TODO get into state from https://ipapi.co/json/
};
export default config;
